import { GridCustomCellProps } from "@progress/kendo-react-grid";
import { useEffect, useState } from "react";
import { TeamProfileAutocomplete } from "../../../forms/form-input-components/selects/team-profile-autocomplete";
import { useTableNavigation } from "../table-navigation-context";
import { useBulkChange } from "./use-bulk-change.hook";
import { useTableCellNavigation } from "./use-table-cell-navigation.hook";
import "./custom-cells.css";

export const TechnicianSelectCustomCell = (props: GridCustomCellProps) => {
	const [profileId, setProfileId] = useState<string | null>(null);

	const { handleChange } = useBulkChange({
		dataItem: props.dataItem,
		dataIndex: props.dataIndex,
		field: props.field,
		onChange: props.onChange,
	});

	const { visibleTechnicianGroupFields } = useTableNavigation();

	const { handleKeyDown: handleNavigationKeyDown } = useTableCellNavigation({
		field: props.field,
		dataIndex: props.dataIndex,
		horizontalGroup: visibleTechnicianGroupFields,
		focusSelector: (targetField: string, targetRowIndex: number) => {
			if (targetField.includes('techn_perc')) {
				return `input[data-field="${targetField}"][data-row-index="${targetRowIndex}"]`;
			}
			return `[data-testid="technician-autocomplete-trigger"][data-field="${targetField}"][data-row-index="${targetRowIndex}"]`;
		},
	});

	useEffect(() => {
		if (props.field) {
			setProfileId(props.dataItem[props.field]);
		}
	}, [props.dataItem, props.field]);

	const handleProfileChange = (value: string | null, metaKeyPressed: boolean = false, shiftKeyPressed: boolean = false, altKeyPressed: boolean = false) => {
		handleChange(value, metaKeyPressed, shiftKeyPressed, altKeyPressed);
	};

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if(e.defaultPrevented) return;

		if (e.key === "Backspace") {
			e.preventDefault();
			handleProfileChange(null, e.metaKey || e.ctrlKey, e.shiftKey, e.altKey);
			return;
		}

		handleNavigationKeyDown(e);
	};

	return (
		<td className="custom-td">
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					padding: 0,
					width: "100%",
				}}
				onKeyDown={handleKeyDown}
			>
				<TeamProfileAutocomplete
					onBulkSelect={(value, metaKeyPressed, shiftKeyPressed, altKeyPressed) => handleProfileChange(value, metaKeyPressed, shiftKeyPressed, altKeyPressed)}
					onChange={(value) => handleProfileChange(value)}
					value={profileId}
					size="small"
					field={props.field}
					rowIndex={props.dataIndex}
				/>
			</div>
		</td>
	);
};
